// Idle watcher (docs/06 §8): the UI measures stillness and tells the sim how long it has lasted, so
// the Maw can notice (a line at 2 min, it falls asleep at 10) and the Last Supper can see a Hunger
// Strike at 3. Real time never enters the sim; the command carries the minutes.
import { audio } from '../audio/audio';
import { B } from '../content/balance';
import { getRenderer } from '../render';
import { dispatch, getGame, getUI } from '../state/store';

const MARKS = [B.IDLE_LINE_MIN, B.HUNGER_STRIKE_MIN, B.ASLEEP_MIN];

export function installIdleWatcher(): void {
  let last = Date.now();
  let sent = new Set<number>();
  let asleep = false;
  const wake = () => {
    last = Date.now();
    sent = new Set();
    if (asleep) {
      asleep = false;
      audio.music.duck(0, 0);
      const r = getRenderer();
      if (r) r.player.applyMood(getGame());
    }
  };
  for (const ev of ['pointerdown', 'keydown', 'wheel'] as const) window.addEventListener(ev, wake, { capture: true, passive: true });
  setInterval(() => {
    const ui = getUI();
    const run = getGame().run;
    if (ui.screen !== 'machine' || !run || run.phase === 'consumed' || ui.busy) return;
    const minutes = (Date.now() - last) / 60000;
    for (const m of MARKS) {
      if (minutes < m || sent.has(m)) continue;
      sent.add(m);
      dispatch({ t: 'IDLE', minutes: m });
      if (m >= B.ASLEEP_MIN) {
        asleep = true;
        audio.music.duck(-12, 60 * 60 * 1000);
      }
    }
  }, 5000);
}
